<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :loading="loading"
      :columns="tableColumns"
      :toolbar-config="tableToolbar"
      size="mini"
      :height="200"
      border
      :checkbox-config="{
        highlight: true
      }"
      :header-cell-style="headerCellStyle"
    >
      <template v-slot:toolbar_form>
        <slot name="header"> </slot>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
        >
          <i
            class="el-icon-delete tool-btn"
            @click="del(row.changeOrderTechDocSpecCode)"
          ></i>
        </el-tooltip>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      tableColumns: tableColumns(this),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        }
      }
    }
  },
  methods: {
    headerCellStyle({ column, columnIndex }) {
      if (column.property !== 'xxx') {
        return {
          backgroundColor: '#bd94c1',
          color: '#ffffff'
        }
      }
    },
    getCheckboxRecords() {
      const $vxeGrid = this.$refs.vxeGrid
      const data = $vxeGrid.getCheckboxRecords()
      if (!data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据!',
          type: 'warning'
        })
        return
      }
      return data
    },
    del(changeOrderTechDocSpecCode) {
      this.$emit('del', changeOrderTechDocSpecCode)
    }
  }
}
</script>
